<script>
import DialogButton from "./dialog-button.vue";

export default {
    name: "dialog-actionbar",
    components: {DialogButton},
    props: {
        disableSave: Boolean,
        disableKeypress: Boolean,
        noIcons: {
            type: Boolean,
            default: true
        },
        processing: Boolean,
        confirmText: {
            type: String,
            default: Lang.langGet('Save')
        },
        abortText: {
            type: String,
            default: Lang.langGet('Close')
        },
        confirmIcon: {
            type: String,
            default: 'fa-floppy-disk'
        },
        abortIcon: {
            type: String,
            default: 'fa-xmark'
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleSave() {
            this.$emit('save');
        },
        onEnterPressed(event) {
            if (this.disableKeypress) return;
            event.stopImmediatePropagation();
            // console.log('Enter Pressed!');

            if (this.disableSave) return;
            if (this.processing) return;

            if (event.key === 'Enter') {
                this.handleSave();
            }
            if (event.key === 'Escape') {
                this.handleCancel();
            }
        }
    },
    mounted() {
        document.body.addEventListener('keypress', this.onEnterPressed);
    },
    destroyed() {
        document.body.removeEventListener('keypress', this.onEnterPressed);
    }
}
</script>

<template>
    <div @keyup.enter="onEnterPressed" class="pa-4">
        <div class="d-flex w-100 justify-space-between px-0">
            <slot>
                <div style="width: 1px" />
            </slot>
            <div class="d-flex flex-column">
                <div class="h-100 d-flex align-end">
                    <dialog-button
                        class="mr-1"
                        :disabled="disableSave || processing"
                        :color="'primary'"
                        @click="handleSave"
                    >
                        <i v-if="!noIcons"
                           class="mr-1 fa-light fa-fw fa-lg"
                           :class="confirmIcon" />
                        {{ confirmText }}
                    </dialog-button>
                    <dialog-button
                        @click="handleClose"
                        :disabled="processing"
                        :color="'secondary'"
                    >
                        <i v-if="!noIcons"
                           class="mr-1 fa-light fa-fw fa-lg"
                           :class="abortIcon" />
                        {{ abortText }}
                    </dialog-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .w-100 {
        width: 100%;
    }
    .h-100 {
        height: 100%;
    }
</style>
